// -------------------------------------
// #FIX JQUERY PASSIVE LISTENER
// -------------------------------------

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {
            passive: !ns.includes("noPreventDefault"),
        });
    },
};

jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {
            passive: !ns.includes("noPreventDefault"),
        });
    },
};

jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    },
};

jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    },
};

// -------------------------------------
// #FUNCTIONS
// -------------------------------------

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        };
    }

    // -------------------------------------
    // Definir variaveis de CSS
    // -------------------------------------

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document
    var header = $('#header');

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); // We listen to the resize event

    if (header) {
        var headerHeight = header.outerHeight();
        document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
    }

    window.addEventListener('resize', debounce(function(){
        // We execute the same script as before
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

        if (header) {
            headerHeight = header.outerHeight();
            document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
        }
    }, 100));

    // -------------------------------------
    // Verificar qual tamanho da barra de rolagem
    // -------------------------------------

    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
        document.documentElement.style.setProperty('--scrollbar-width', "".concat(scrollbarWidth, "px"));

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    var scrollbar = getScrollbarWidth();

    // -------------------------------------
    // Stick header
    // -------------------------------------
    var headerTopDistance = $(window).scrollTop();

    if (headerTopDistance > 100) {
        header.addClass("header-stick");
    }

    // Scroll listener
    window.addEventListener('scroll', debounce(function(){
        headerTopDistance = $(window).scrollTop();

        if (headerTopDistance > 100) {
            header.addClass("header-stick");
        } else {
            header.removeClass("header-stick");
        }
    }, 10));

    // -------------------------------------
    // Menu Mobile / Search
    // -------------------------------------

    // Menu mobile vars
    var btnMenuMobile = $(".btn-menu-mobile");
    var menuMobile = $(".menu-mobile");
    var menuOverlay = $(".menu-mobile-overlay");

    // Search vars
    var btnSearch = $(".btn-search");
    var searchBlock = $(".header-search-block");
    var searchOverlay = $(".search-overlay");

    // Open menu mobile
    function openMenuMobile() {
        var headerMobileHeight = header.outerHeight();

        btnMenuMobile.addClass("is-active");
        menuMobile.addClass("is-active");
        header.addClass("menu-mobile-active");
        menuOverlay.fadeIn();
        menuMobile.css({ "padding-top": headerMobileHeight - 1 + "px" });
        $("html").css({ "margin-right": scrollbar + "px", overflow: "hidden" });
    }

    // Close menu mobile
    function closeMenuMobile() {
        btnMenuMobile.removeClass("is-active");
        menuMobile.removeClass("is-active");
        header.removeClass("menu-mobile-active");
        menuOverlay.fadeOut();
    }

    // Trigger menu mobile
    $('[data-menu-mobile="toggle"]').click(function (event) {
        if (menuMobile.hasClass("is-active")) {
            closeMenuMobile();
            setTimeout(function () {
                $("html").css({ "margin-right": "", overflow: "" });
            }, 300);
        } else {
            openMenuMobile();
        }
    });

    // Open submenu mobile
    $(".mobile-nav .menu-item-has-children").click(function (event) {
        $(".mobile-nav .sub-menu .menu-item").click(function (event) {
            event.stopPropagation();
        });
        if ($(this).children(".sub-menu").is(":visible")) {
            $(this).removeClass("is-active");
            $(this).children(".sub-menu").slideUp();
        } else {
            $(this).addClass("is-active");
            $(this).children(".sub-menu").slideDown();
        }
    });

    // Open search
    function openSearch() {
        closeMenuMobile();
        header.addClass("search-active");
        searchBlock.addClass("is-active");
        searchOverlay.fadeIn();
        searchBlock.fadeIn();
        searchBlock.find('.search-input').focus();
        $("html").css({ "margin-right": scrollbar + "px", overflow: "hidden" });
    }

    // Close search
    function closeSearch() {
        header.removeClass("search-active");
        searchBlock.removeClass("is-active");
        searchOverlay.fadeOut();
        searchBlock.fadeOut();
        setTimeout(function () {
            $("html").css({ "margin-right": "", overflow: "" });
        }, 300);
    }

    // Trigger search
    /*
    $('[data-search="toggle"]').click(function (event) {
        if (searchBlock.hasClass("is-active")) {
            closeSearch();
        } else {
            openSearch();
        }
    });
    */

    $('[data-search="open"]').click(function (event) {
        if (!searchBlock.hasClass("is-active")) {
            openSearch();
        }
    });

    $('[data-search="close"]').click(function (event) {
        if (searchBlock.hasClass("is-active")) {
            closeSearch();
        }
    });

    // -------------------------------------
    // Menu horizontal de filtros
    // -------------------------------------

    var filterInner = $('.filter-inner');
    var filterList = $('.filter-list');

    if ($("body").has(".filter-inner").length) {
        var filterPrev = $('#filter-prev');
        var filterNext = $('#filter-next');

        if ($(filterList).get(0).scrollWidth - $(filterList).outerWidth() > 1) {
            $(filterInner).removeClass('no-scroll');
        }

        $(filterPrev).click(function () {
            $(filterList).animate({
                scrollLeft: '-=150'
            }, 300, 'swing');
        });

        $(filterNext).click(function () {
            $(filterList).animate({
                scrollLeft: '+=150'
            }, 300, 'swing');
        });

        $(filterList).scroll(function() {
            if ($(this).scrollLeft() > 5) {
                $(filterInner).addClass('is-scrolled');
            } else if ($(filterInner).hasClass('is-scrolled')) {
                $(filterInner).removeClass('is-scrolled');
            }
            // checar se scrollou totalmente ate a direita
            var divWidth = $(this).outerWidth();
            var scrollwidth = $(this).get(0).scrollWidth;
            if($(this).scrollLeft() >= scrollwidth - divWidth - 5){
                $(filterInner).addClass('is-full-scrolled');
            } else if ($(filterInner).hasClass('is-full-scrolled')) {
                $(filterInner).removeClass('is-full-scrolled');
            }
        });

        window.addEventListener('resize', debounce(function(){
            if ($(filterList).get(0).scrollWidth - $(filterList).outerWidth() > 1) {
                $(filterInner).removeClass('no-scroll');
            } else {
                $(filterInner).addClass('no-scroll');
            }
        }, 100));
    }

    // -------------------------------------
    // Menu lateral de categorias
    // -------------------------------------

    // Open category menus
    $(".cat-list .has-subcategory > a").click(function (event) {
        if ($(this).siblings(".sub-menu").is(":visible")) {
            $(this).parent().removeClass("is-active");
            $(this).siblings(".sub-menu").slideUp();
        } else {
            $(".cat-list .has-subcategory").children(".sub-menu").slideUp();
            $(".cat-list .has-subcategory").removeClass("is-active");
            $(this).parent().addClass("is-active");
            $(this).siblings(".sub-menu").slideDown();
        }
    });

    // Open categories mobile
    $('[data-cat-menu="toggle"]').click(function (event) {
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $(this).siblings('.side-content').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).siblings('.side-content').slideDown();
        }
    });

    // -------------------------------------
    // FAQ
    // -------------------------------------

    $('[data-faq="toggle"]').click(function(event) {
        if ($(this).siblings('.item-text').is(':hidden')) {
            $('.faq-item').removeClass('is-active');
            $('.faq-item .item-text').slideUp();
            $(this).parent('.faq-item').addClass('is-active');
            $(this).siblings('.item-text').slideDown();
        } else {
            $(this).parent('.faq-item').removeClass('is-active');
            $(this).siblings('.item-text').slideUp();
        }
    });

    // -------------------------------------
    // Anchor Scroll
    // -------------------------------------

    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr("href"));
            var target = hash.length ? hash : $("[name=" + this.hash.slice(1) + "]");

            var pageWidth = $(window).width();
            var headerOffset = 41;
            if (pageWidth < 480) {
                headerOffset = 11;
            } else if (pageWidth < 1280) {
                headerOffset = 21;
            }

            if (target.length) {
                $("html, body").animate({
                    scrollTop: target.offset().top - (headerHeight - headerOffset),
                }, 1000);

                // Mudar hash na URL
                history.pushState({}, "", el.href);
            }
        }
    });

    $('a[href="#"]:not(.cd-upload-btn)').click(function () {
        $("html, body").animate({
            scrollTop: 0,
        }, 1000);
    });

    // -------------------------------------
    // Magnific Popup
    // -------------------------------------

    $(".gallery-popup, .wp-block-gallery").each(function () {
        // the containers for all your galleries
        $(this).magnificPopup({
            delegate: "a",
            type: "image",
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: "Carregando a imagem...",
            mainClass: "mfp-no-margins mfp-fade",
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: "A imagem não pode ser carregada.",
            },
        });
    });

    var getLocation = function(href) {
        var l = document.createElement("a");
        l.href = href;
        return l;
    };

    $(".video-popup").magnificPopup({
        // disableOn: 700,
        delegate: "a",
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 300,
        preloader: false,
        fixedContentPos: true,
        iframe: {
            patterns: {
                youtube: {
                    index: "youtube.com/", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: "v=", // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: "//www.youtube.com/embed/%id%?autoplay=1", // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: function getVimeoVideoId(url) {
                        var urlPath = getLocation(url);
                        urlPath = urlPath.pathname.split("/");
                        var urlFinal = urlPath[1] + "?autoplay=1";

                        if (urlPath.length > 2) {
                            urlFinal =
                                urlPath[1] + "?h=" + urlPath[2] + "&autoplay=1";
                        }

                        return urlFinal;
                    },
                    src: "//player.vimeo.com/video/%id%",
                },
            },
        },
    });
});

// -------------------------------------
//   AOS
// -------------------------------------

/*
AOS.init({
  // Global settings
  disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

  // Settings that can be overriden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1100, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});
*/
